import type { BlogPost } from "./blog";

export const BLOG_FAQ_PART1: BlogPost[] = [
  {
    "slug": "kak-zabronirovat-stol-restoran-peterburg",
    "title": "Как забронировать стол в ресторане Петербурга: инструкция",
    "metaTitle": "Как забронировать стол в ресторане Петербурга — инструкция | Паруса",
    "metaDescription": "Как забронировать стол в ресторане Санкт-Петербурга? Онлайн, по телефону, через приложение. «Паруса на крыше» — бронирование стола за 2 минуты.",
    "keywords": "забронировать стол ресторан петербург, как бронировать ресторан спб, онлайн бронирование ресторан петербург",
    "date": "2026-06-01",
    "category": "Вопросы и ответы",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "Бронирование стола в ресторане — 2 минуты, если знать куда нажать. Разбираем все способы и рассказываем, как забронировать лучший столик в «Парусах на крыше».",
    "sections": [
      {
        "heading": "Способы бронирования",
        "body": "Три способа забронировать стол в «Парусах»: 1. Онлайн через форму на сайте — быстро, без звонка. 2. По телефону +7 (812) 991-10-90 — можно уточнить детали живьём. 3. В социальных сетях ресторана (директ). Самый надёжный для особых пожеланий — телефон: можно запросить конкретный столик, договориться о сюрпризе, уточнить меню.",
        "list": [
          "Сайт: онлайн форма бронирования",
          "Телефон: +7 (812) 991-10-90",
          "Социальные сети: директ сообщение",
          "Для особых пожеланий — телефон надёжнее"
        ]
      },
      {
        "heading": "Что указать при бронировании",
        "body": "Обязательно: дата и время, количество гостей, имя и телефон для связи. Дополнительно (важно для особых случаев): повод (день рождения, свадьба, деловой ужин), пожелание по столику (у окна с видом), дополнительные пожелания (цветы, торт, шампанское). Чем больше информации — тем лучше подготовится персонал.",
        "highlight": "Лайфхак: скажите «столик у окна с видом на Казанский собор» при бронировании — официант назначит лучший стол в зале."
      },
      {
        "heading": "За сколько дней бронировать",
        "body": "Будни (ланч/ужин): можно в день посещения, лучше за 1–2 дня. Выходные (пятница/суббота): за 3–5 дней минимум. Особые даты (ДР, 14 февраля, 8 Марта): за 2–3 недели. Корпоративы и банкеты: за 1–3 месяца. Новый год: в августе-сентябре."
      }
    ],
    "cta": {
      "text": "Забронировать стол прямо сейчас",
      "href": "/"
    }
  },
  {
    "slug": "est-li-skidka-imeninniku-restoran",
    "title": "Есть ли скидка именинникам в ресторане «Паруса на крыше»?",
    "metaTitle": "Скидка именинникам в ресторане «Паруса на крыше» — FAQ",
    "metaDescription": "Есть ли скидка на день рождения в ресторане «Паруса на крыше»? Да — скидка 20% на весь счёт именинника в течение 7 дней до и после дня рождения.",
    "keywords": "скидка именинник ресторан паруса, скидка день рождения паруса на крыше, именинник скидка спб",
    "date": "2026-06-01",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Да, в «Парусах на крыше» действует скидка для именинников. Рассказываем, как она работает и как её получить.",
    "sections": [
      {
        "heading": "Условия скидки именинникам",
        "body": "Скидка 20% на счёт именинника. Действует в течение 7 дней до и 7 дней после дня рождения. Оплата при использовании скидки — наличными. При бронировании нужно сообщить о дне рождения. Документы: паспорт или другой документ с датой рождения при необходимости.",
        "list": [
          "Скидка: 20% на счёт именинника",
          "Период: 7 дней до + день рождения + 7 дней после",
          "Оплата: наличными",
          "Сообщите при бронировании: +7 (812) 991-10-90"
        ]
      },
      {
        "heading": "На что распространяется скидка",
        "body": "Скидка 20% применяется на счёт именинника — то есть на его/её часть заказа. Если вся компания хочет воспользоваться скидкой — это не распространяется на счёт гостей, только на именинника. Алкоголь обычно входит в счёт. Уточните условия при бронировании.",
        "highlight": "Экономия: при счёте именинника в 3 000 ₽ скидка составит 600 ₽. При счёте 6 000 ₽ — 1 200 ₽. Для банкета именинника на 20 человек с чеком 30 000 ₽ — экономия 6 000 ₽."
      },
      {
        "heading": "Как не забыть активировать скидку",
        "body": "Главный совет: сообщите о дне рождения при бронировании, а не в ресторане. Это позволяет персоналу подготовиться: украсить столик, приготовить поздравление. В день визита напомните официанту при заказе. Оплата — наличными, заблаговременно приготовьте."
      }
    ],
    "cta": {
      "text": "Забронировать с учётом скидки именинника",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "kak-doekhat-olimpik-plaza-peterburg",
    "title": "Как добраться до Olympic Plaza в Петербурге: маршруты",
    "metaTitle": "Как добраться до Olympic Plaza в Петербурге — маршруты | Паруса",
    "metaDescription": "Как доехать до Olympic Plaza (ул. Марата 5) в Санкт-Петербурге? Метро, автобус, такси, парковка. «Паруса на крыше» — 6-й этаж Olympic Plaza.",
    "keywords": "как добраться olympic plaza петербург, маршрут olympic plaza спб, olympic plaza ул марата 5 как добраться",
    "date": "2026-06-01",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/view_day.webp",
    "lead": "Olympic Plaza (ул. Марата, 5) — хорошо связана с городом. Несколько способов добраться до «Парусов на крыше».",
    "sections": [
      {
        "heading": "Метро: самый удобный вариант",
        "body": "Ближайшие станции метро: Маяковская (3 линия): выход на ул. Марата → прямо 400 метров → Olympic Plaza слева. Время: 5 минут пешком. Достоевская (5 линия): выход → ул. Кузнечный → ул. Марата → 7 минут пешком. Vladimirskaya (4 линия): через Загородный проспект, 10 минут.",
        "list": [
          "Маяковская: выход ул. Марата → 5 минут пешком",
          "Достоевская: 7 минут пешком",
          "Владимирская: 10 минут пешком"
        ]
      },
      {
        "heading": "Автомобиль и такси",
        "body": "Парковка: подземная парковка Olympic Plaza (платная, по часам). Въезд с ул. Марата. Такси: в навигаторе вводите «Olympic Plaza, ул. Марата 5» или «Паруса на крыше». От Невского до ресторана: 7–10 минут на машине. От Московского вокзала: 10–15 минут. При плохой погоде такси — лучший вариант.",
        "highlight": "Навигатор: вводите «Olympic Plaza Санкт-Петербург» или «ул. Марата 5 Паруса на крыше» — выведет точно."
      },
      {
        "heading": "Как найти ресторан в здании",
        "body": "Вход в Olympic Plaza: со стороны ул. Марата (главный вход). Внутри: поверните налево к лифтовой зоне → лифт на 6-й этаж → выйдите, увидите вывеску «Паруса на крыше» → вход в ресторан прямо. Если запутались — спросите охрану на входе."
      }
    ],
    "cta": {
      "text": "Забронировать стол и приехать",
      "href": "/"
    }
  },
  {
    "slug": "mozhno-li-priness-tort-v-restoran",
    "title": "Можно ли принести свой торт в ресторан «Паруса на крыше»?",
    "metaTitle": "Можно ли принести торт в ресторан «Паруса на крыше» — FAQ",
    "metaDescription": "Можно ли принести свой торт в ресторан «Паруса на крыше»? Условия, альтернативы от шефа. Ответы на вопросы гостей.",
    "keywords": "принести торт в ресторан паруса, торт ресторан паруса на крыше, можно ли торт ресторан спб",
    "date": "2026-06-01",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/food.webp",
    "lead": "Вопрос о торте — один из самых частых при планировании дня рождения. Разбираем, как это работает в «Парусах на крыше».",
    "sections": [
      {
        "heading": "Свой торт: можно ли и при каких условиях",
        "body": "Да, принести торт от внешней кондитерской можно при предварительном согласовании. Сообщите при бронировании. Ресторан может взимать плату за сервировку (нарезка, тарелки, вилки) — уточните при звонке. Размер торта: учитывайте количество гостей (1,5–2 кг на 10 человек). Доставка: заказывайте доставку прямо в ресторан к началу вечера.",
        "list": [
          "Внешний торт: допускается при согласовании",
          "Сервировочная плата: уточните при бронировании",
          "Доставка: в ресторан к началу вечера",
          "Размер: 1,5–2 кг на 10 человек"
        ]
      },
      {
        "heading": "Торт от шефа: авторский вариант",
        "body": "Альтернатива — торт от шеф-кондитера ресторана. Авторский дизайн, персональная надпись, стилизован под повод. Заказывается при бронировании за 2–3 дня. Цена: зависит от размера и оформления — уточните у менеджера. Плюс: торт идеально вписывается в концепцию вечера и сочетается с кухней ресторана.",
        "highlight": "Рекомендуем торт от шефа: авторский дизайн с надписью выглядит гармоничнее на фото, чем внешний торт в непривычной обстановке."
      },
      {
        "heading": "Момент выноса торта",
        "body": "Торжественный вынос торта со свечами — по запросу. Персонал подготовит стол, зажгут свечи, при наличии живых музыкантов — сыграют «Happy Birthday». Это 3–5 минут, которые создают главный момент вечера. Заранее скажите официанту, когда нести торт — обычно между горячим и финальным кофе."
      }
    ],
    "cta": {
      "text": "Забронировать с тортом от шефа",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "est-li-parkinga-paruса",
    "title": "Есть ли парковка у ресторана «Паруса на крыше»?",
    "metaTitle": "Парковка у ресторана «Паруса на крыше» — FAQ",
    "metaDescription": "Есть ли парковка у ресторана «Паруса на крыше»? Подземная парковка Olympic Plaza, бесплатная/платная, альтернативы. Ответы на вопросы гостей.",
    "keywords": "парковка паруса на крыше, паркинг паруса ресторан, олимпик плаза парковка ресторан",
    "date": "2026-06-02",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/view_day.webp",
    "lead": "Да, у Olympic Plaza есть подземная парковка. Разбираем условия и альтернативы.",
    "sections": [
      {
        "heading": "Подземная парковка Olympic Plaza",
        "body": "Подземная парковка Olympic Plaza (ул. Марата, 5) доступна для гостей ресторана. Въезд с ул. Марата. Режим работы: уточняйте актуально при звонке в ресторан. Стоимость: платная, по часам (стандартная парковка в центре). Для гостей ресторана возможны льготные условия — уточните при бронировании.",
        "list": [
          "Подземная парковка Olympic Plaza: въезд с ул. Марата",
          "Платная, по часам",
          "Льготы для гостей ресторана: уточняйте при бронировании",
          "Телефон: +7 (812) 991-10-90"
        ]
      },
      {
        "heading": "Альтернативы парковке",
        "body": "Платные парковки рядом: ул. Разъезжая, ул. Воронежская — платные городские парковки. Метро: самый удобный вариант — Маяковская (5 минут) или Достоевская (7 минут). Такси: от любой точки центра — 5–15 минут. В центре Петербурга метро нередко быстрее машины.",
        "highlight": "Совет: для особых вечеров (ДР, романтика) рекомендуем такси — не нужно беспокоиться о парковке и лимите алкоголя. Вечер будет более расслабленным."
      },
      {
        "heading": "Парковка для корпоративов и банкетов",
        "body": "Для больших мероприятий (30+ гостей) рекомендуем заранее уточнить у менеджера ситуацию с парковкой — для группы могут быть организованы дополнительные места или договорённости. Для корпоративов: многие компании заказывают трансфер или корпоративное такси."
      }
    ],
    "cta": {
      "text": "Забронировать стол и уточнить парковку",
      "href": "/"
    }
  },
  {
    "slug": "est-li-vegetarianskoe-menyu-v-parusakh",
    "title": "Есть ли вегетарианское меню в «Парусах на крыше»?",
    "metaTitle": "Вегетарианское меню в ресторане «Паруса на крыше» — FAQ",
    "metaDescription": "Есть ли вегетарианское меню в «Парусах на крыше»? Какие блюда подходят для вегетарианцев? Ответы на вопросы гостей.",
    "keywords": "вегетарианское меню паруса на крыше, вегетарианец ресторан паруса, веган паруса ресторан",
    "date": "2026-06-02",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/food.webp",
    "lead": "Да, в «Парусах» есть блюда для вегетарианцев — интегрированные в основное меню. Разбираем, что подойдёт и как заказать.",
    "sections": [
      {
        "heading": "Вегетарианские блюда в меню",
        "body": "Ризотто с белыми грибами и пармезаном (строгим веганам — без пармезана по запросу). Паста с сезонными овощами. Авторские салаты. Суп дня (часто без мяса — уточняйте у официанта). Большинство десертов. Авторские закуски на основе овощей.",
        "list": [
          "Ризотто с грибами: без мяса и рыбы",
          "Паста с овощами: сезонный вариант",
          "Суп дня: часто вегетарианский (уточняйте)",
          "Десерты: большинство без мяса"
        ]
      },
      {
        "heading": "Как заказывать вегетарианцу",
        "body": "Скажите официанту «я вегетарианец» или «я веган» в начале. Хорошая кухня адаптирует блюда: например, ризотто без пармезана для строгого вегана. Уточните что конкретно исключаете: мясо, рыбу, морепродукты, яйца, молочное. Спросите о блюде дня — часто есть что-то сезонное.",
        "highlight": "Лучший совет: позвоните при бронировании и предупредите о вегетарианских/веганских ограничениях — кухня подготовит адаптированные варианты. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Строгий веган: что возможно",
        "body": "Строгим веганам (без яиц, молочного, мёда) в «Парусах» доступны: ризотто без пармезана (на растительном масле), паста с томатным соусом и овощами, салаты с растительной заправкой. Выбор ограниченный, но достаточный. Предупредите заранее — шеф может подготовить специальное блюдо дня."
      }
    ],
    "cta": {
      "text": "Забронировать и предупредить о диете",
      "href": "/"
    }
  },
  {
    "slug": "skolko-stoit-uzhin-v-parusakh",
    "title": "Сколько стоит ужин в ресторане «Паруса на крыше»?",
    "metaTitle": "Сколько стоит ужин в «Парусах на крыше» — цены | FAQ",
    "metaDescription": "Сколько стоит ужин в ресторане «Паруса на крыше» в Санкт-Петербурге? Цены блюд, средний чек, бизнес-ланч. Честный ответ.",
    "keywords": "цены паруса на крыше, средний чек паруса ресторан, сколько стоит паруса на крыше",
    "date": "2026-06-02",
    "category": "Вопросы и ответы",
    "readTime": 4,
    "image": "/photos/food.webp",
    "lead": "Честный ответ на главный вопрос: сколько стоит поужинать в «Парусах на крыше» и что входит в эту сумму.",
    "sections": [
      {
        "heading": "Цены на блюда в «Парусах»",
        "body": "Закуски: 400–900 ₽. Супы: 400–700 ₽. Горячее: 700–1 800 ₽. Десерты: 350–700 ₽. Бокал вина: 500–900 ₽. Бокал игристого: 600–1 000 ₽.",
        "list": [
          "Бизнес-ланч от 590 ₽ — будни 12:00–16:00",
          "Средний чек: ≈ 1 300 ₽/чел. без алкоголя",
          "С бокалом вина: ≈ 1 800–2 200 ₽/чел.",
          "Банкетное меню: от 2 500 ₽/чел."
        ]
      },
      {
        "heading": "Что входит в средний чек 1 300 ₽",
        "body": "При среднем чеке 1 300 ₽ получаете: одно блюдо закуски (600–700 ₽) + горячее (800–1 000 ₽) + напиток (200 ₽) или суп (400 ₽) + горячее (900 ₽) + десерт (500 ₽). Это полноценный ужин с видом на Петербург. Для сравнения: аналогичный уровень на Невском стоит 1 500–2 000 ₽.",
        "highlight": "Лучшее соотношение: бизнес-ланч от 590 ₽ в будни. Полный обед с авторской кухней и видом на Казанский собор за цену обычного кафе."
      },
      {
        "heading": "Как спланировать бюджет",
        "body": "Ужин для двоих без алкоголя: 2 600–4 000 ₽. Ужин для двоих с бокалом вина: 3 500–5 500 ₽. Романтический ужин с шампанским: 5 000–8 000 ₽. Банкет на 20 человек (банкетное меню): 50 000 ₽ + алкоголь."
      }
    ],
    "cta": {
      "text": "Посмотреть актуальное меню с ценами",
      "href": "/menu"
    }
  },
  {
    "slug": "est-li-zhivaya-muzika-v-parusakh",
    "title": "Есть ли живая музыка в ресторане «Паруса на крыше»?",
    "metaTitle": "Живая музыка в ресторане «Паруса на крыше» — расписание | FAQ",
    "metaDescription": "Есть ли живая музыка в «Парусах на крыше»? Расписание, жанры, как узнать о концертах. Ответы на вопросы гостей.",
    "keywords": "живая музыка паруса на крыше, концерты паруса ресторан, расписание музыка паруса",
    "date": "2026-06-02",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Да, в «Парусах» регулярно звучит живая музыка. Разбираем расписание, жанры и как попасть на выступление.",
    "sections": [
      {
        "heading": "Расписание живой музыки",
        "body": "Регулярные выступления: пятница и суббота — живая музыка по афише. Специальные концерты: несколько раз в месяц, анонсируются заранее в афише. Музыка для мероприятий: на корпоративы, банкеты, дни рождения — по запросу и заказу.",
        "list": [
          "Пятница/суббота — регулярная живая музыка",
          "Афиша на сайте: /afisha",
          "Специальные концерты: анонсируются заранее",
          "Заказная программа для мероприятий: по запросу"
        ]
      },
      {
        "heading": "Какая музыка звучит",
        "body": "Основной жанр: джаз. Форматы: джазовые дуэты (рояль + вокал), трио, квартеты. Репертуар: мировые джазовые стандарты, французская шансон в джазовой аранжировке, авторские композиции. Уровень: петербургские профессиональные исполнители.",
        "highlight": "Проверьте афишу перед выбором даты: если совпадёте с выступлением — живая музыка войдёт в вечер без дополнительных затрат. Расписание: /afisha."
      },
      {
        "heading": "Как заказать музыку для мероприятия",
        "body": "Для корпоратива, дня рождения или банкета: укажите при бронировании, что хотите живую музыку. Менеджер уточнит ваши пожелания (жанр, репертуар, продолжительность) и подберёт исполнителей. Стоимость уточняется отдельно. Рекомендуем заказывать за 2–3 недели минимум."
      }
    ],
    "cta": {
      "text": "Проверить афишу и забронировать",
      "href": "/afisha"
    }
  },
  {
    "slug": "do-kakogo-vremeni-rabotaet-restoran-parusy",
    "title": "До какого времени работает ресторан «Паруса на крыше»?",
    "metaTitle": "Режим работы ресторана «Паруса на крыше» — FAQ",
    "metaDescription": "Режим работы ресторана «Паруса на крыше» в Санкт-Петербурге. Часы работы, когда открывается, поздний ужин. Актуальная информация.",
    "keywords": "режим работы паруса на крыше, часы работы паруса ресторан, когда открывается паруса",
    "date": "2026-06-03",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Часы работы «Парусов на крыше» зависят от дня недели. Разбираем режим и советуем, когда лучше прийти.",
    "sections": [
      {
        "heading": "Часы работы «Парусов»",
        "body": "Ресторан открыт в понедельник–четверг и воскресенье с 12:00 до 23:00, в пятницу и субботу — с 12:00 до 01:00 следующего дня. Бизнес-ланч: будние дни, 12:00–16:00. Время приёма заказов кухней уточняйте при бронировании. В праздничные дни режим может отличаться.",
        "list": [
          "Ланч (будни): 12:00–16:00",
          "Пн–Чт, Вс: 12:00–23:00",
          "Пт–Сб: 12:00–01:00 следующего дня",
          "Праздники: уточняйте режим заранее"
        ]
      },
      {
        "heading": "Когда лучше приходить",
        "body": "Будний ланч (12:30–14:00): пик, может быть занято — лучше бронировать. Будний ужин (18:00–20:00): тихо, идеально для деловых встреч. Пятница/суббота (19:00–22:00): живая музыка, самый атмосферный период — бронировать за 3–5 дней. Воскресенье вечер: спокойно, хорошо для семейного/парного ужина.",
        "highlight": "Для позднего ужина (после 21:00) — уточните при бронировании, до которого времени принимает кухня. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Поздний ужин в «Парусах»",
        "body": "В пятницу и субботу ресторан открыт до 01:00 следующего дня, в остальные дни — до 23:00. Если планируете поздний ужин, уточните время приёма заказов кухней при бронировании. В праздничные дни режим может отличаться."
      }
    ],
    "cta": {
      "text": "Уточнить время и забронировать",
      "href": "/"
    }
  },
  {
    "slug": "est-li-detskoe-menyu-v-parusakh",
    "title": "Есть ли детское меню в ресторане «Паруса на крыше»?",
    "metaTitle": "Детское меню в ресторане «Паруса на крыше» — FAQ",
    "metaDescription": "Есть ли детское меню в «Парусах на крыше»? Что могут заказать дети? Подходит ли ресторан для семей с детьми.",
    "keywords": "детское меню паруса на крыше, дети паруса ресторан, семья с детьми паруса",
    "date": "2026-06-03",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "В «Парусах» нет отдельного «детского меню» с картинками, но есть блюда, которые дети любят, и персонал, который умеет с ними работать.",
    "sections": [
      {
        "heading": "Что заказать детям в «Парусах»",
        "body": "Из основного меню подходят детям: паста с томатным или сливочным соусом, рыбные блюда без острых специй (по запросу — без острого), куриные позиции (если есть в меню), авторские десерты. Напитки: свежевыжатые соки, авторские лимонады, компоты. Высокий стул: уточните наличие при бронировании.",
        "list": [
          "Паста (томатный или сливочный соус) — детский фаворит",
          "Рыба без острых специй — по запросу",
          "Десерты от шефа — дети любят",
          "Соки и лимонады без газа"
        ]
      },
      {
        "heading": "Ресторан для семей: что нужно знать",
        "body": "Просторный зал — места хватает, с коляской не проблема. Ранний вечер (17:00–18:30) — меньше гостей, больше внимания семье. Персонал привыкший к детям — относятся с пониманием. Вид на Петербург — способ занять ребёнка: покажите Казанский собор, объясните что видно.",
        "highlight": "Лайфхак: попросите официанта рассказать ребёнку о виде из окна. Хороший персонал превращает это в маленькую экскурсию."
      },
      {
        "heading": "Подходит ли «Паруса» для семейного ужина",
        "body": "Да, с оговорками. Это не детский ресторан с игровой зоной — здесь нет аниматоров и детского уголка. Но это правильное место для семейного ужина, где взрослые хотят хорошо поесть, а дети — попробовать что-то вкусное. Ориентируйтесь на ребёнка старше 4 лет."
      }
    ],
    "cta": {
      "text": "Забронировать семейный ужин",
      "href": "/"
    }
  },
  {
    "slug": "mozhno-li-arендovat-zal-v-parusakh",
    "title": "Можно ли арендовать зал в «Парусах на крыше» для мероприятия?",
    "metaTitle": "Аренда зала в «Парусах на крыше» — FAQ",
    "metaDescription": "Можно ли арендовать зал в ресторане «Паруса на крыше»? Условия, вместимость, цены. Банкетный зал с видом на Петербург до 300 гостей.",
    "keywords": "аренда зала паруса на крыше, зал мероприятия паруса ресторан, банкетный зал паруса",
    "date": "2026-06-03",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Да, в «Парусах» можно арендовать отдельное пространство для мероприятий. Разбираем условия, вместимость и что включено.",
    "sections": [
      {
        "heading": "Варианты аренды зала",
        "body": "Выделенная зона (до 30 гостей): часть общего зала, только ваша компания, без дополнительной аренды при заказе банкетного меню. Банкетный зал (до 100 гостей): отдельный зал с полным оснащением. Большой банкетный зал (до 300 гостей): профессиональная сцена, звук, свет. Открытая терраса (лето): до 50 гостей в хорошую погоду.",
        "list": [
          "До 30 гостей: выделенная зона без доп. аренды",
          "До 100 гостей: банкетный зал с оснащением",
          "До 300 гостей: большой зал с профессиональной сценой",
          "Лето: открытая терраса до 50 гостей"
        ]
      },
      {
        "heading": "Условия аренды",
        "body": "Аренда зала: включена при заказе банкетного меню или à la carte на минимальную сумму (уточняется у менеджера). Минимальный заказ: зависит от размера группы и дня недели. Что включено: мебель в нужной расстановке, посуда и столовые приборы, профессиональное освещение, для банкетных залов — звук, свет, микрофон.",
        "highlight": "Важно: аренда зала не взимается отдельно — только при заказе меню на минимальную сумму. Это прозрачная схема: платите за еду и напитки, зал входит в стоимость."
      },
      {
        "heading": "Как забронировать зал",
        "body": "Для мероприятия звоните менеджеру: +7 (812) 991-10-90. Обсуждение: дата, количество гостей, формат мероприятия, меню, технические потребности. После согласования: договор и предоплата для фиксации даты. Рекомендуем бронировать за 4–8 недель для мероприятий 30+ человек."
      }
    ],
    "cta": {
      "text": "Обсудить аренду зала для мероприятия",
      "href": "/banket"
    }
  },
  {
    "slug": "est-li-wifi-v-parusakh",
    "title": "Есть ли Wi-Fi в ресторане «Паруса на крыше»?",
    "metaTitle": "Wi-Fi в ресторане «Паруса на крыше» — FAQ",
    "metaDescription": "Есть ли Wi-Fi в ресторане «Паруса на крыше»? Ответ и другие практические вопросы о посещении ресторана.",
    "keywords": "wifi паруса на крыше, интернет паруса ресторан, паруса ресторан вай фай",
    "date": "2026-06-04",
    "category": "Вопросы и ответы",
    "readTime": 2,
    "image": "/photos/interior.webp",
    "lead": "Практические вопросы о посещении «Парусов на крыше»: Wi-Fi, оплата, гардероб и другие бытовые детали.",
    "sections": [
      {
        "heading": "Wi-Fi и практические вопросы",
        "body": "Wi-Fi: да, бесплатный Wi-Fi для гостей. Пароль можно узнать у официанта. Оплата: банковские карты (Visa, MasterCard, МИР), наличные. Для скидки именинника — только наличными. Гардероб: есть, бесплатный. Для банкетов — гардероб при большом количестве гостей организуется заранее.",
        "list": [
          "Wi-Fi: есть, бесплатный",
          "Оплата: карты + наличные",
          "Скидка именинника: только наличными",
          "Гардероб: бесплатный"
        ]
      },
      {
        "heading": "Дресс-код",
        "body": "Дресс-кода нет в строгом смысле. Ресторан авторской кухни с панорамным видом — гости обычно приходят в ухоженной повседневной одежде или смарт-кэжуал. Спортивная одежда: формально не запрещена, но явно контрастирует с атмосферой. На особые события (день рождения, романтика): оденьтесь немного нарядней — это добавит настроения.",
        "highlight": "Для деловых встреч: бизнес-кэжуал. Для романтического ужина: smart-casual. Для корпоратива: по дресс-коду компании."
      },
      {
        "heading": "Ещё несколько практических деталей",
        "body": "Курение: не разрешено внутри. Животные: уточните в ресторане — условия могут меняться. Фотографировать: можно, без специальных ограничений. Кальян: уточните наличие при бронировании. Аллергии: сообщите официанту заранее — кухня учтёт при приготовлении."
      }
    ],
    "cta": {
      "text": "Подготовиться к визиту и забронировать",
      "href": "/"
    }
  },
  {
    "slug": "kak-uznat-raspisanie-kontsertov-parusy",
    "title": "Как узнать расписание концертов в «Парусах на крыше»?",
    "metaTitle": "Расписание концертов «Паруса на крыше» — FAQ",
    "metaDescription": "Как узнать расписание концертов и мероприятий в ресторане «Паруса на крыше»? Афиша, социальные сети, телефон.",
    "keywords": "расписание концертов паруса на крыше, афиша паруса ресторан, мероприятия паруса спб",
    "date": "2026-06-04",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Следить за расписанием концертов в «Парусах» — несложно. Разбираем, где публикуется афиша.",
    "sections": [
      {
        "heading": "Где найти расписание концертов",
        "body": "Три источника: 1. Раздел «Афиша» на сайте ресторана — /afisha. 2. Социальные сети «Парусов» (ВКонтакте, Instagram) — анонсы и фото выступлений. 3. Телефон +7 (812) 991-10-90 — уточните, что выступает в нужную дату.",
        "list": [
          "/afisha — расписание на сайте",
          "ВКонтакте и Instagram ресторана — анонсы",
          "Телефон: +7 (812) 991-10-90 — живая информация",
          "При бронировании: спросите о концертах в ваш вечер"
        ]
      },
      {
        "heading": "Как выбрать дату с живой музыкой",
        "body": "Регулярные выступления: пятница и суббота вечером. Специальные концерты: уточняйте по афише. Если хотите попасть именно на живую музыку — бронируйте пятницу или субботу. Если хотите спокойный ужин — будний вечер без концерта.",
        "highlight": "Совет: перед бронированием позвоните и уточните «будет ли живая музыка в пятницу 15-го?» — это точнее любой афиши."
      },
      {
        "heading": "Как заказать концерт для вашего мероприятия",
        "body": "Для корпоративов, дней рождения, свадеб: живую музыку заказывают отдельно при бронировании. Уточните жанр, продолжительность, состав (дуэт, трио, квартет). Оплачивается отдельно от банкетного меню. Рекомендуем заказывать за 2–3 недели."
      }
    ],
    "cta": {
      "text": "Посмотреть афишу концертов",
      "href": "/afisha"
    }
  },
  {
    "slug": "mozhno-li-otmetit-svadbu-v-parusakh",
    "title": "Можно ли отметить свадьбу в ресторане «Паруса на крыше»?",
    "metaTitle": "Свадьба в ресторане «Паруса на крыше» — FAQ",
    "metaDescription": "Можно ли отметить свадьбу в «Парусах на крыше»? Вместимость, свадебное меню, выездная регистрация. Ответы на вопросы о свадебных торжествах.",
    "keywords": "свадьба паруса на крыше, свадебный банкет паруса, свадьба ресторан паруса",
    "date": "2026-06-04",
    "category": "Вопросы и ответы",
    "readTime": 4,
    "image": "/photos/view_sunset.webp",
    "lead": "Да, «Паруса на крыше» проводят свадьбы. За 15 лет работы здесь прошли сотни свадебных торжеств. Разбираем детали.",
    "sections": [
      {
        "heading": "Свадьба в «Парусах»: возможности",
        "body": "Вместимость: до 300 гостей (банкетный зал), до 150 (сидячий ужин), до 30–50 (камерная свадьба). Свадебное меню: несколько вариантов банкетного меню от 2 500 ₽/чел., с возможностью адаптации. Оформление: можно приносить своего флориста или использовать партнёров ресторана. Живая музыка: по запросу.",
        "list": [
          "Вместимость до 300 гостей",
          "Свадебное меню от 2 500 ₽/чел.",
          "Выездная регистрация: возможна в зале",
          "Вид на Петербург — лучшая декорация"
        ]
      },
      {
        "heading": "Выездная регистрация в «Парусах»",
        "body": "Да, ресторан работает с выездными регистрациями. Официальный регистратор (ЗАГС) приезжает в ресторан. После церемонии — банкет в том же зале. Это удобный формат: одно место для всего, никаких переездов. Альтернатива — символическая церемония (без юридической силы, но очень красивая).",
        "highlight": "Для свадьбы на 50+ гостей: начинайте переговоры за 4–6 месяцев. Лучшие летние даты разбирают в феврале-марте. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Что включает свадебный пакет",
        "body": "При бронировании свадьбы в «Парусах» обсуждается: состав меню и дегустация, программа вечера (тайминг, ведущий), оформление зала, живая музыка, торт. Каждая свадьба индивидуальна — менеджер помогает собрать пакет под ваш бюджет и пожелания."
      }
    ],
    "cta": {
      "text": "Обсудить свадьбу с менеджером",
      "href": "/svadba"
    }
  },
  {
    "slug": "est-li-akvarel-dostопrimechatelnosti-паруса",
    "title": "Обзор ресторана «Паруса на крыше»: всё что нужно знать",
    "metaTitle": "Ресторан «Паруса на крыше» — полный обзор | FAQ",
    "metaDescription": "Полный обзор ресторана «Паруса на крыше» в Санкт-Петербурге. История, кухня, вид, цены, бронирование. Всё о ресторане в одной статье.",
    "keywords": "паруса на крыше обзор ресторан, паруса на крыше отзывы информация, ресторан паруса спб обзор",
    "date": "2026-06-05",
    "category": "Вопросы и ответы",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Всё о ресторане «Паруса на крыше» в одном месте: история, кухня, вид, цены, поводы для посещения и практические детали.",
    "sections": [
      {
        "heading": "Коротко о главном",
        "body": "«Паруса на крыше» — ресторан на 6-м этаже Olympic Plaza (ул. Марата, 5) в историческом центре Санкт-Петербурга. Работают с 2009 года. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах. Звание «Хорошее место 2026». Авторская кухня с продуктами Северо-Запада. Живая музыка по расписанию. Банкетный зал до 300 гостей.",
        "list": [
          "Адрес: ул. Марата 5, Olympic Plaza, 6 этаж",
          "Телефон: +7 (812) 991-10-90",
          "Рейтинг: 5,0 / 2 606 отзывов на Яндекс Картах",
          "Работают с 2009 года"
        ]
      },
      {
        "heading": "Кухня и цены",
        "body": "Авторская кухня с продуктами Северо-Запада: балтийская рыба, карельские грибы, северные ягоды. Меню обновляется 4 раза в год. Бизнес-ланч от 590 ₽ (будни 12:00–16:00). Блюда à la carte от 490 ₽. Средний чек ≈ 1 300 ₽/чел. без алкоголя. Банкетное меню от 2 500 ₽/чел.",
        "highlight": "Главные фирменные блюда: гребешки с цветной капустой и икрой, блюда на хоспере, авторские десерты от шеф-кондитера."
      },
      {
        "heading": "Для каких поводов подходит",
        "body": "Романтический ужин: угловые столики у панорамного окна, живая музыка, вид на закат. День рождения: скидка 20% именинникам (7 дней до и после), торт от шефа, живая музыка. Корпоратив: банкетный зал до 300 человек, профессиональная сцена. Свадьба: выездная регистрация + банкет. Деловая встреча: бизнес-ланч от 590 ₽ или ужин в выделенной зоне. Читайте также: <a href=\"/blog/restorany-s-vidom-na-peterburg\" class=\"underline text-accent\">рестораны с видом на Петербург</a>."
      }
    ],
    "cta": {
      "text": "Забронировать стол в «Парусах»",
      "href": "/"
    }
  },
  {
    "slug": "kak-zakazat-zal-korporativ-parusy",
    "title": "Как заказать зал для корпоратива в «Парусах на крыше»?",
    "metaTitle": "Как заказать зал для корпоратива в «Парусах» — FAQ",
    "metaDescription": "Как заказать банкетный зал для корпоратива в «Парусах на крыше»? Пошаговая инструкция, что нужно обсудить с менеджером.",
    "keywords": "заказать зал корпоратив паруса, как организовать корпоратив паруса, паруса банкетный зал корпоратив",
    "date": "2026-06-05",
    "category": "Вопросы и ответы",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "Пошаговая инструкция: как организовать корпоратив в «Парусах на крыше» от первого звонка до дня мероприятия.",
    "sections": [
      {
        "heading": "Шаг 1: первый звонок менеджеру",
        "body": "Позвоните по +7 (812) 991-10-90 и сообщите: примерное количество гостей, желаемую дату (или диапазон дат), формат (ужин, банкет с программой, фуршет). Менеджер предложит доступные варианты и расскажет о возможностях. Этот разговор занимает 10–15 минут.",
        "list": [
          "Количество гостей: ваш главный параметр",
          "Дата: конкретная или диапазон",
          "Формат: ужин или банкет с программой",
          "Бюджет: назовите ориентировочный"
        ]
      },
      {
        "heading": "Шаг 2: встреча и осмотр зала",
        "body": "Для мероприятий 30+ человек рекомендуем лично посетить ресторан и осмотреть зал. Менеджер покажет пространство, обсудит расстановку столов, технические возможности (сцена, звук, экран). После осмотра — согласование меню и программы. Дегустация меню: доступна при бронировании.",
        "highlight": "Договоритесь об экскурсии по залу: это бесплатно и помогает принять правильное решение. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Шаг 3: договор и предоплата",
        "body": "После согласования деталей: договор о проведении мероприятия, предоплата для фиксации даты (уточните размер у менеджера). За 1–2 недели до мероприятия: финализация количества гостей, уточнение деталей (рассадка, тайминг, меню). В день мероприятия: менеджер ресторана присутствует и координирует."
      }
    ],
    "cta": {
      "text": "Позвонить и обсудить корпоратив",
      "href": "/korporativ"
    }
  },
  {
    "slug": "est-li-programma-loyalnosti-parusy",
    "title": "Есть ли программа лояльности в «Парусах на крыше»?",
    "metaTitle": "Программа лояльности «Паруса на крыше» — FAQ",
    "metaDescription": "Есть ли программа лояльности и скидки для постоянных гостей в ресторане «Паруса на крыше»? Ответы и актуальная информация.",
    "keywords": "программа лояльности паруса ресторан, скидки постоянным гостям паруса, бонусы паруса на крыше",
    "date": "2026-06-05",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Вопрос о программах лояльности в «Парусах на крыше»: что доступно и как получить лучшие условия как постоянный гость.",
    "sections": [
      {
        "heading": "Текущие скидки и бонусы",
        "body": "Скидка именинникам 20%: 7 дней до и после дня рождения, оплата наличными. Банкетные условия: при заказе мероприятий — аренда зала входит в стоимость меню. Другие акции и специальные предложения: уточняйте у менеджера — могут быть сезонные предложения.",
        "list": [
          "Скидка именинникам 20% — основная акция",
          "7 дней до + 7 дней после дня рождения",
          "Банкеты: аренда зала включена в меню",
          "Сезонные акции: уточняйте при бронировании"
        ]
      },
      {
        "heading": "Привилегии постоянных гостей",
        "body": "Формальной карточки лояльности может не быть, но постоянные гости получают привилегии по-другому: персонал запоминает предпочтения (любимый столик, любимые блюда), гибкость в специальных просьбах (торт, украшение), приоритет при бронировании в загруженные даты. Это называется «human loyalty» — и работает лучше карточки.",
        "highlight": "Совет: при повторном визите напомните официанту «мы были у вас на прошлой неделе» — в хорошем ресторане вас запомнят и уделят больше внимания."
      },
      {
        "heading": "Как стать постоянным гостем",
        "body": "Просто приходить регулярно, рассказывать о предпочтениях, возвращаться в одно время. Через 2–3 визита вас начнут узнавать. Через 5–6 визитов — у вас появится «свой» официант и «свой» столик. Это самая ценная программа лояльности в хорошем ресторане."
      }
    ],
    "cta": {
      "text": "Стать постоянным гостем «Парусов»",
      "href": "/"
    }
  },
  {
    "slug": "mozhno-li-provesti-foto-sessiu-v-parusakh",
    "title": "Можно ли провести фотосессию в ресторане «Паруса на крыше»?",
    "metaTitle": "Фотосессия в ресторане «Паруса на крыше» — FAQ",
    "metaDescription": "Можно ли провести фотосессию в ресторане «Паруса на крыше»? Условия, лучшие ракурсы, как согласовать. Ответы на вопросы.",
    "keywords": "фотосессия паруса ресторан, фото паруса на крыше ресторан, фотограф паруса спб",
    "date": "2026-06-06",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/view_sunset.webp",
    "lead": "Фотосессия в «Парусах» — популярный запрос для свадеб, дней рождения и просто красивых фото. Разбираем условия.",
    "sections": [
      {
        "heading": "Фотографирование для гостей",
        "body": "Гости могут фотографироваться в ресторане без ограничений: телефон, любительский фотоаппарат, штатив по договорённости. Лучшие точки для фото: угловой столик у панорамного окна с видом на Казанский собор (попросите его при бронировании), вид на ночной Петербург из зала, открытая терраса с куполами на фоне. Официанты охотно делают фото гостей по просьбе.",
        "list": [
          "Телефон и любительская камера: без ограничений",
          "Лучшее освещение: дневной свет 12:00–15:00 или «золотой час» 19:00–21:00",
          "Попросите официанта сделать фото — они умеют",
          "Вид на Казанский собор — лучший фон в городе"
        ]
      },
      {
        "heading": "Профессиональная фотосессия",
        "body": "Для профессиональных фотосессий (свадебные, fashion, коммерческие) — договаривайтесь заранее с менеджером. Ресторан обычно идёт навстречу, но нужно согласовать время (когда меньше гостей) и условия. Идеальное время: за час до открытия (утром) или в будний день в не пиковые часы.",
        "highlight": "Для свадебной фотосессии: попросите менеджера организовать «фотопаузу» — 15–20 минут без гостей для фото пары у панорамного окна. Это стандартная практика."
      },
      {
        "heading": "Лучшие ракурсы для фото в «Парусах»",
        "body": "1. Пара у панорамного окна с Казанским собором на фоне. 2. Вид с тарелкой — красиво поданные блюда. 3. Вид из окна без людей (рано утром). 4. Открытая терраса летом. 5. Зал с ночным видом на Петербург."
      }
    ],
    "cta": {
      "text": "Забронировать фотосессию + ужин",
      "href": "/"
    }
  },
  {
    "slug": "kak-otmenit-bronirovanie-restoran",
    "title": "Как отменить или изменить бронирование в «Парусах на крыше»?",
    "metaTitle": "Отмена бронирования «Паруса на крыше» — FAQ",
    "metaDescription": "Как отменить или изменить бронирование в ресторане «Паруса на крыше»? Условия отмены, как связаться. Ответы на вопросы гостей.",
    "keywords": "отменить бронирование паруса ресторан, изменить бронь паруса на крыше, бронирование паруса условия отмены",
    "date": "2026-06-06",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/interior.webp",
    "lead": "Планы изменились? Разбираем, как отменить или перенести бронирование в «Парусах» и в каких случаях это бесплатно.",
    "sections": [
      {
        "heading": "Отмена столика (ужин/ланч)",
        "body": "Для обычного столика (не банкет): отмените заранее — желательно за 2–4 часа до визита. Это поможет ресторану освободить место для других гостей. Звоните: +7 (812) 991-10-90. Штрафы: обычно нет для отмены ужина/ланча — уточните при бронировании. Перенос даты: звоните и договаривайтесь — обычно без проблем.",
        "list": [
          "Ужин/ланч: отменяйте за 2–4 часа",
          "Штрафов обычно нет",
          "Перенос: звоните и договаривайтесь",
          "Телефон: +7 (812) 991-10-90"
        ]
      },
      {
        "heading": "Отмена банкета/мероприятия",
        "body": "Для мероприятий (корпоратив, свадьба, банкет): условия прописываются в договоре. Обычно: отмена за 30+ дней — без штрафа или возврат предоплаты. Отмена за 7–30 дней — частичный штраф. Отмена за 7 дней — предоплата не возвращается. Конкретные условия уточняйте при заключении договора.",
        "highlight": "Главный совет: при любых сомнениях — звоните сразу. Ресторан всегда готов найти компромиссное решение для постоянных гостей."
      },
      {
        "heading": "Форс-мажор и особые обстоятельства",
        "body": "Если что-то случилось (болезнь, срочные обстоятельства): звоните как можно скорее. Хороший ресторан войдёт в положение при личном звонке. Для мероприятий: форс-мажорные оговорки обычно прописываются в договоре. Действуйте заблаговременно — это даёт больше возможностей для решения."
      }
    ],
    "cta": {
      "text": "Связаться с рестораном по телефону",
      "href": "/"
    }
  },
  {
    "slug": "gde-nakhoditsya-restoran-parusy-spb",
    "title": "Где находится ресторан «Паруса на крыше» в Санкт-Петербурге?",
    "metaTitle": "Где находится ресторан «Паруса на крыше» — адрес и карта",
    "metaDescription": "Адрес ресторана «Паруса на крыше» в Санкт-Петербурге. Ул. Марата 5, Olympic Plaza, 6-й этаж. Как добраться, телефон.",
    "keywords": "где находится паруса на крыше, адрес паруса ресторан спб, паруса на крыше где",
    "date": "2026-06-06",
    "category": "Вопросы и ответы",
    "readTime": 3,
    "image": "/photos/view_day.webp",
    "lead": "Адрес «Парусов на крыше», как добраться и что важно знать перед первым визитом.",
    "sections": [
      {
        "heading": "Адрес и контакты",
        "body": "Ресторан «Паруса на крыше»: Санкт-Петербург, ул. Марата, 5, Olympic Plaza, 6-й этаж. Телефон: +7 (812) 991-10-90. Режим: ланч будни 12:00–16:00, ужин ежедневно.",
        "list": [
          "Адрес: ул. Марата 5, Санкт-Петербург",
          "ТЦ Olympic Plaza, 6-й этаж",
          "Телефон: +7 (812) 991-10-90",
          "Метро: Маяковская (5 мин.) или Достоевская (7 мин.)"
        ]
      },
      {
        "heading": "Ориентиры и навигация",
        "body": "От метро Маяковская: выход на ул. Марата → прямо 400 метров → Olympic Plaza слева. Видна вывеска Olympic Plaza. Вход с ул. Марата. Лифт на 6-й этаж. При входе в лифт — нажмите «6». Выйдите из лифта — вывеска «Паруса на крыше» прямо перед вами.",
        "highlight": "В навигаторе введите: «Olympic Plaza Санкт-Петербург» или «Паруса на крыше ресторан Санкт-Петербург» — обе фразы выводят правильно."
      },
      {
        "heading": "Рядом с рестораном",
        "body": "Казанский собор: 700 метров (10 минут пешком). Невский проспект: 500 метров (7 минут). Эрмитаж: 2 км (25 минут пешком или 7 минут на такси). Спас на Крови: 900 метров (12 минут). Михайловский замок: 700 метров (10 минут)."
      }
    ],
    "cta": {
      "text": "Забронировать стол",
      "href": "/"
    }
  }
];
